import { render, staticRenderFns } from "./AgeStudentsGraph.vue?vue&type=template&id=19781cd5&scoped=true"
import script from "./AgeStudentsGraph.vue?vue&type=script&lang=js"
export * from "./AgeStudentsGraph.vue?vue&type=script&lang=js"
import style0 from "./AgeStudentsGraph.vue?vue&type=style&index=0&id=19781cd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19781cd5",
  null
  
)

export default component.exports